import React, { useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); refresh(); return; }
        if (data.status === "expired" || tries > 8) { setStatus("error"); return; }
      } catch (e) { if (tries > 8) { setStatus("error"); return; } }
      tries += 1;
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="eti-card rounded-2xl p-10 max-w-md text-center" data-testid="payment-success-page">
        {status === "checking" && <><Loader2 className="h-12 w-12 text-primary mx-auto animate-spin" /><h2 className="font-display text-2xl font-bold text-white mt-4 uppercase">Confirming Payment</h2><p className="text-slate-400 mt-2">Hang tight, verifying with Stripe...</p></>}
        {status === "paid" && <><CheckCircle2 className="h-12 w-12 text-emerald-400 mx-auto" /><h2 className="font-display text-2xl font-bold text-white mt-4 uppercase">Payment Confirmed</h2><p className="text-slate-400 mt-2">You're all set. Your connection & membership are active.</p><Button onClick={() => navigate("/dashboard")} className="mt-6 bg-primary hover:bg-primary/90 text-white font-semibold" data-testid="payment-success-dashboard">Go to Dashboard</Button></>}
        {status === "error" && <><XCircle className="h-12 w-12 text-red-400 mx-auto" /><h2 className="font-display text-2xl font-bold text-white mt-4 uppercase">Something Went Wrong</h2><p className="text-slate-400 mt-2">We couldn't confirm your payment. Please try again.</p><Link to="/pricing"><Button className="mt-6 bg-primary text-white">Back to Pricing</Button></Link></>}
      </div>
    </div>
  );
};

export const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="eti-card rounded-2xl p-10 max-w-md text-center" data-testid="payment-cancel-page">
        <XCircle className="h-12 w-12 text-slate-500 mx-auto" />
        <h2 className="font-display text-2xl font-bold text-white mt-4 uppercase">Payment Cancelled</h2>
        <p className="text-slate-400 mt-2">No charge was made. You can pick up where you left off anytime.</p>
        <Button onClick={() => navigate("/pricing")} className="mt-6 bg-primary hover:bg-primary/90 text-white font-semibold" data-testid="payment-cancel-back">Back to Pricing</Button>
      </div>
    </div>
  );
};
